export default __webpack_public_path__ + "static/media/Robo_DLOPS.c7a705c3.svg";